module.exports = __webpack_public_path__ + "static/media/software_solution.947cd0e3.svg";